// TB-152: one slot card everywhere. The single source for the consultation type
// (icon, name, colour) and the slot state (name, palette key) used by SlotCard.vue.
import { visitKindOf, visitTypeLabel } from '@/utils/visitTypes'
import { formatClock, formatWall } from '@/utils/locale'
import { formatFee } from '@/utils/money'

export const SLOT_STATES = ['free', 'held', 'booked', 'pending', 'cancelled', 'past', 'blocked']

export const SLOT_STATE_NAME = {
  free: 'Free',
  held: 'Held',
  booked: 'Booked',
  pending: 'Pending',
  cancelled: 'Cancelled',
  past: 'Past',
  blocked: 'Blocked'
}

// Doctor calendar state (utils/slots.js) -> card state. An unpaid video booking is 'pending'
// (callers pass it when awaitingPayment(appt)).
const FROM_CALENDAR = { free: 'free', booked: 'booked', confirmed: 'booked', completed: 'past', blocked: 'blocked', past: 'past', cancelled: 'cancelled' }
export function cardState (state) { return FROM_CALENDAR[state] || 'free' }

export function slotTypeKind (t) { return visitKindOf(t) }
export function slotTypeName (t) { return visitTypeLabel(t) }

const HAS_DATE = /\d{4}-\d{2}-\d{2}/

/**
 * Clock text. "HH:mm[:ss]" (a slot's wall time) is shown as is; a wall datetime
 * ("YYYY-MM-DD HH:mm:ss", "...Z" as appointments carry) follows the display time mode.
 */
export function clockText (t) {
  if (HAS_DATE.test(String(t || ''))) return formatWall(t, 'time')
  const m = /^(\d{1,2}):(\d{2})/.exec(String(t || ''))
  return m ? formatClock(`${m[1].padStart(2, '0')}:${m[2]}`) : ''
}

/** { a, b }: start and end texts; a drops its AM/PM when b carries the same one ("9:00", "9:30 AM"). */
export function rangeParts (start, end) {
  const a = clockText(start)
  const b = clockText(end)
  if (!a || !b || a === b) return { a, b: '' }
  const m = /\s*([AaPp][Mm])$/.exec(a)
  return m && b.toLowerCase().endsWith(m[1].toLowerCase()) ? { a: a.slice(0, a.length - m[0].length), b } : { a, b }
}

export function rangeText (start, end) {
  const { a, b } = rangeParts(start, end)
  return b ? `${a} - ${b}` : a
}

export function priceText (n) {
  const v = Number(n)
  return Number.isFinite(v) && v > 0 ? formatFee(v) : ''
}
